<template>
  <v-dialog v-model="dialog" max-width="500px" transition="dialog-transition">
    <v-card>
      <template v-if="loading">
        <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
      </template>
      <v-card-title primary-title>
        Convo Tip {{ isUpdating ? 'Update' : 'Create' }}
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="depth"
          label="depth"
          type="number"
          :rules="[(v) => v > 0 || 'Depth must be bigger than 0']"
          required
        ></v-text-field>
        <v-textarea
          v-model="text"
          label="text"
          :counter="200"
          :rules="[(v) => (v || '').length <= 200 || 'Text must be 500 characters or less']"
          required
        />
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" rounded :disabled="loading || isDisabled" @click="save">{{
          isUpdating ? 'Update' : 'Create'
        }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="gray" rounded outlined :disabled="loading" @click="dialog = false"
          >Close</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { RequestConvoTips } from '../../../../requests/admin/convo-tips';

export default {
  props: {
    selectedTip: Object || null,
    onUpdated: Function,
    onCreated: Function,
  },

  data() {
    return {
      dialog: false,
      loading: false,
      depth: 0,
      text: '',
    };
  },

  computed: {
    isUpdating() {
      return this.selectedTip != null;
    },

    isDisabled() {
      return this.text.length == 0 || this.depth <= 0;
    },
  },

  methods: {
    openDialog() {
      this.dialog = true;

      if (this.selectedTip == null) {
        this.clearForm();
        return;
      }

      this.depth = this.selectedTip.depth;
      this.text = this.selectedTip.text;
    },

    clearForm() {
      this.depth = 0;
      this.text = '';
    },

    async save() {
      if (this.isDisabled) return;

      this.loading = true;

      const formData = new FormData();
      formData.append('depth', this.depth);
      formData.append('text', this.text);

      try {
        if (this.isUpdating) {
          const updatedTip = await RequestConvoTips.update(this.selectedTip.id, formData);
          this.onUpdated(updatedTip);
        } else {
          const newTip = await RequestConvoTips.create(formData);
          this.onCreated(newTip);
        }
        this.dialog = false;
      } catch (e) {
        alert(e);
        // Don't close the modal when error.
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
